import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Spinner from '../util/Spinner';

const EmailConfirmation = () => {
  const location = useLocation();
  const { hash, search } = location;
  const [changes, setChanges] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);

  const status = {
    mode: search.slice(8),
    payload: {
      action: hash.split('|')[0].slice(1),
      id: `auth0|${hash.split('|')[1]}`,
    },
  };

  const checkForChanges = async () => {
    if (status.mode === 'confirm') {
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}/api/update-email-confirm`,
          {
            authId: status.payload.id,
            hash: status.payload.action,
          },
        );
        if (data.errno) {
          setErrorMsg(data.message);
        } else {
          setChanges(data);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    } else if (status.mode === 'reject') {
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}/api/update-email-reject`,
          {
            authId: status.payload.id,
            hash: status.payload.action,
          },
        );
        setChanges(data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleConfirm = () => {
    const { EmailTo } = changes;
    axios.post(`${process.env.REACT_APP_API}/api/manage-profile`, {
      email: EmailTo,
      userId: status.payload.id,
    });
  };

  const handleReject = () => {
    const { EmailFrom } = changes;
    axios.post(`${process.env.REACT_APP_API}/api/manage-profile`, {
      email: EmailFrom,
      userId: status.payload.id,
    });
  };
  useEffect(() => {
    checkForChanges();
  }, []);

  useEffect(() => {
    if (!loading && !errorMsg) {
      if (status.mode === 'confirm') {
        handleConfirm();
      } else if (status.mode === 'reject') {
        handleReject();
      }
    }
  }, [loading]);
  if (loading) return <Spinner />;
  return (
    <div>
      {errorMsg && <h3>{errorMsg}</h3>}
      {status.mode === 'confirm' && changes && (
        <h3>Email change confirmed you may login using your new credentials</h3>
      )}
      {status.mode === 'reject' && changes && (
        <h3>
          {' '}
          Email change rejected, your account will maintain its initial email
          credentials.
        </h3>
      )}
    </div>
  );
};

export default EmailConfirmation;
